import { useEffect } from 'react';
import { Location } from 'react-router';
import { stripRoutePrefix } from 'services/theming';
import { setPreviousRoute, setLastVisitedRoute, getLastVisitedRoute } from 'utils/routeHistory.utils';

const useRouteTracker = (location: Location) => {
  useEffect(() => {
    const currentRoute = `${location.pathname}${location.search}${location.hash}`;
    const lastVisitedRoute = getLastVisitedRoute();

    // If this is a different route from last visited, store last visited as previous
    if (lastVisitedRoute && lastVisitedRoute !== currentRoute) {
      setPreviousRoute(stripRoutePrefix(lastVisitedRoute));
    }

    // Always update last visited to current route
    setLastVisitedRoute(currentRoute);
  }, [location]);

  return null;
};

export default useRouteTracker;
